import GoogleIcon from "../../../assets/images/jpeg/google_review.png";
import Avatarmage from "../../../assets/images/svg/user.svg";
import styles from "./courseTestimonials.module.css";

const truncate = (text, max = 200) => {
  const clean = text?.trim() || "";
  return clean.length > max ? `${clean.slice(0, max).trim()}...` : clean;
};

const TestimonialCard = ({ testimony }) => (
  <article
    className={`${styles.testimonialCard} bg-white text-[#1E2027] rounded-2xl p-6 flex flex-col flex-none`}
  >
    {testimony?.source === "google" && (
      <div className="w-14 mb-4">
        <img src={GoogleIcon} alt="Google" />
      </div>
    )}
    <blockquote className="text-xs leading-relaxed flex-1 m-0">
      {truncate(testimony?.testimony)}
    </blockquote>
    <div className="flex items-center gap-3 mt-6">
      <img
        src={testimony?.image || Avatarmage}
        alt=""
        className="w-10 h-10 rounded-full object-cover flex-none"
      />
      <p className="m-0">
        <strong className="block text-xs">
          {testimony?.firstname} {testimony?.lastname}
        </strong>
        <small className="text-[#565656] text-[10px]">
          {testimony?.company}
        </small>
      </p>
    </div>
  </article>
);

const duplicate = (list) => [...list, ...list];

const CourseTestimonialsSection = ({ testimonies }) => {
  if (!testimonies?.length) return null;

  const firstRow = testimonies.slice(0, Math.ceil(testimonies.length / 2));
  const secondRow = testimonies.slice(Math.ceil(testimonies.length / 2));

  return (
    <section id="stories" className="bg-primary overflow-hidden">
      <div className="max-w-[1260px] mx-auto px-4 pt-16 md:pt-20">
        <div className="text-center max-w-xl mx-auto mb-10">
          <h2 className="text-3xl font-poppins md:text-[38px] font-bold text-white mb-3">
            What our Talents are saying about Utiva
          </h2>
          <p className="text-[#F0F5FF] text-xs md:text-sm m-0">
            Trusted by thousands of professionals across Nigeria and beyond.
          </p>
        </div>
      </div>

      <div className={`${styles.carouselContainer} pb-16 md:pb-20`}>
        <div className={`${styles.carouselRow} ${styles.scrollRight}`}>
          {duplicate(firstRow).map((testimony, index) => (
            <TestimonialCard
              key={`${testimony.id}-a-${index}`}
              testimony={testimony}
            />
          ))}
        </div>
        {secondRow.length > 0 && (
          <div className={`${styles.carouselRow} ${styles.scrollLeft}`}>
            {duplicate(secondRow).map((testimony, index) => (
              <TestimonialCard
                key={`${testimony.id}-b-${index}`}
                testimony={testimony}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default CourseTestimonialsSection;
